/**
 * Which `WorldAudioController` is live on this page, so a module that is not inside
 * `World.tsx` (the project SoundHost, which ducks the world's ambient under a project's own
 * loop — sound-and-music R4.4) can reach it without threading a ref through every surface.
 */
import type { WorldAudioController } from "./WorldAudioController";

let active: WorldAudioController | null = null;

export function setActiveWorldAudio(ctrl: WorldAudioController | null): void {
  active = ctrl;
}

export function getActiveWorldAudio(): WorldAudioController | null {
  return active;
}
